import { useEffect, useState } from "react"
import { Timestamp, doc, updateDoc, deleteDoc } from "firebase/firestore"
import { ref, update, remove } from "firebase/database"
import { db, rtdb } from "../../../Firebase/config" // Import RTDB
import Notify from "../Usenotifications"
import { useNavigate } from "react-router-dom"

export const GetDineinorderHook = (id, document) => {
  const [disable, setDisable] = useState(false)
  const [paid, setPaid] = useState("Not Paid")
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem("user"))

  const handlePaid = async (orderId) => {
    if (orderId) {
      const timestamp = Timestamp.now().toDate()

      // Update Firestore
      await updateDoc(doc(db, "Orders", orderId), {
        Paid: true,
        paidAT: timestamp,
      })

      // Update RTDB
      const orderRef = ref(rtdb, `orders/${orderId}`)
      await update(orderRef, {
        Paid: true,
        paidAT: timestamp.toISOString(),
      })

      Notify("Order is Paid", "success")
    }
  }

  const handlePaiddetails = async (e, orderid) => {
    if (e.target.value === "Paid") {
      console.log("done")
      const timestamp = Timestamp.now().toDate()

      // Update Firestore
      await updateDoc(doc(db, "Orders", orderid), {
        Paid: true,
        paidAT: timestamp,
      })

      // Update RTDB
      const orderRef = ref(rtdb, `orders/${orderid}`)
      await update(orderRef, {
        Paid: true,
        paidAT: timestamp.toISOString(),
      })
    }

    setTimeout(() => {
      window.location.reload(false)
    }, 1000)
  }

  const handleDelete = async (e, orderid) => {
    e.preventDefault()
    if (user.email && user.email === process.env.REACT_APP_ADMIN_EMAIL) {
      // Delete from Firestore
      await deleteDoc(doc(db, "Orders", orderid))

      // Delete from RTDB
      const orderRef = ref(rtdb, `orders/${orderid}`)
      await remove(orderRef)

      Notify("Order deleted", "success")
      setTimeout(() => {
        navigate("/adminallorders")
      }, 1500)
    } else {
      Notify("Only Admins can delete Orders ", "error")
    }
  }

  const handleSeen = async (productId, order) => {
    try {
      if (!order) {
        console.log("Order document not found!")
        return
      }

      let updatedCartItems = order.cartItems.map((item) => ({ ...item }))

      const updatedItemIndex = updatedCartItems.findIndex(
        (item) => item.id === productId && item.updatedItem
      )

      if (updatedItemIndex >= 0) {
        const updatedItem = updatedCartItems[updatedItemIndex]
        updatedCartItems.splice(updatedItemIndex, 1)

        const nonUpdatedItemIndex = updatedCartItems.findIndex(
          (item) => item.id === productId && !item.updatedItem
        )

        if (nonUpdatedItemIndex >= 0) {
          updatedCartItems[nonUpdatedItemIndex] = {
            ...updatedCartItems[nonUpdatedItemIndex],
            CartTotalQuantity:
              updatedCartItems[nonUpdatedItemIndex].CartTotalQuantity +
              updatedItem.CartTotalQuantity,
          }
        } else {
          updatedCartItems.push({ ...updatedItem, updatedItem: false })
        }
      }

      // Update Firestore
      await updateDoc(doc(db, "Orders", order.id), {
        updated: false,
        cartItems: updatedCartItems,
      })

      // Update RTDB
      const orderRef = ref(rtdb, `orders/${order.id}`)
      await update(orderRef, {
        updated: false,
        cartItems: updatedCartItems,
      })
    } catch (error) {
      console.error("Error updating item in Firestore:", error)
    }
  }

  const handleCheck = async (orderId) => {
    const today = new Date()
    const date = today.toDateString()
    const time = today.toLocaleTimeString()

    try {
      if (orderId) {
        // Update Firestore
        await updateDoc(doc(db, "Orders", orderId), {
          Checked: true,
          preparing: true,
          SeenAtDate: date,
          SeenAtTime: time,
        })

        // Update RTDB
        const orderRef = ref(rtdb, `orders/${orderId}`)
        await update(orderRef, {
          Checked: true,
          preparing: true,
          SeenAtDate: date,
          SeenAtTime: time,
        })
      }
    } catch (error) {
      console.error("Error updating item in Firestore:", error)
    }
  }

  const handleDone = async (orderId) => {
    const today = new Date()
    const date = today.toDateString()
    const time = today.toLocaleTimeString()

    try {
      if (orderId) {
        // Update Firestore
        await updateDoc(doc(db, "Orders", orderId), {
          Done: true,
          preparing: false,
          DoneAt: date,
          DoneAttime: time,
        })

        // Update RTDB
        const orderRef = ref(rtdb, `orders/${orderId}`)
        await update(orderRef, {
          Done: true,
          preparing: false,
          DoneAt: date,
          DoneAttime: time,
        })
      }
    } catch (error) {
      console.error("Error updating item in Firestore:", error)
    }
  }

  useEffect(() => {
    if (document && document.Paid) {
      setPaid("Paid")
      setDisable(true)
    }
  }, [document])

  return [
    handlePaid,
    handlePaiddetails,
    handleDelete,
    handleSeen,
    handleCheck,
    paid,
    disable,
    handleDone,
  ]
}
